/**
 * T&M Log Helper Functions
 * Shared utility functions for T&M log operations
 */

/**
 * Get the most recent inspector from a list of inspectors
 * @param {Array} inspectors - Array of inspector objects with sent_at timestamps
 * @returns {Object|null} The most recent inspector or null if none exist
 */
export const getLatestInspector = (inspectors) => {
  if (!inspectors || inspectors.length === 0) {
    return null;
  }

  return [...inspectors].sort(
    (a, b) => new Date(b.sent_at) - new Date(a.sent_at)
  )[0];
};
